import React from 'react'
import {NavigationPaths} from '../../types/app-types'
import {Link} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCircleQuestion} from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'

interface BillingActionsProps {
  balance?: number
  paths: NavigationPaths
}

function isPositiveNumber(x: any): boolean {
  return !isNaN(x) && x > 0
}

const BillingActions = ({balance, paths}: BillingActionsProps) => {
  const supportCategory = 'billing'
  const supportSubject = encodeURIComponent(`Question about billing statement`)

  return (
    <div className="flex flex-col flex-col-reverse sm:flex-row items-stretch gap-2">
      <div className="sm:w-1/2 mb-4 sm:my-0 self-end sm:self-start">
        <Link
          className="link link-neutral w-full text-xs sm:text-sm"
          to={`${paths.AddSupportRequest}?category=${supportCategory}&subject=${supportSubject}`}
        >
          <FontAwesomeIcon icon={faCircleQuestion} className="mr-1" />
          Contact us about billing questions
        </Link>
      </div>
      <div className="sm:w-1/2 my-2 sm:my-0">
        <Link
          className={classNames('btn btn-primary w-full', {
            'btn-disabled': !isPositiveNumber(balance)
          })}
          to={`${paths.MakePayment}?amount=${balance}`}
        >
          Pay Now
        </Link>
      </div>
    </div>
  )
}

export default BillingActions
